import type { View } from "../models/TrendingModelsV2";

const normalize = (value: string) =>
	value
		.toLowerCase()
		.replace(/[^\p{L}\p{N}]+/gu, " ")
		.trim();

export const filterViewsByWords = (
	options: View[],
	{ inputValue }: { inputValue: string },
): View[] => {
	const words = normalize(inputValue).split(" ").filter(Boolean);

	if (words.length === 0) return options;

	return options.filter((option) => {
		const viewName = normalize(option.ViewName);
		return words.every((word) => viewName.includes(word));
	});
};
